var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { OidcProvider } from 'redux-oidc';
import { Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from "react-redux";
import { getTranslate, LocalizeProvider } from "react-localize-redux";
import { history } from './store/store';
import axios from "axios";
import { TokenType } from "./interfaces/store/reducers/axios";
import { setAxiosError, setToken } from "./store/actions/axios";
import { queryEncoder, paramsSerializer } from "./utils/common";
var ConnectedApp = (function (_super) {
    __extends(ConnectedApp, _super);
    function ConnectedApp(props) {
        var _this = _super.call(this, props) || this;
        axios.defaults.paramsSerializer = paramsSerializer;
        axios.interceptors.response.use(undefined, _this.axiosInterceptorResponseHandler.bind(_this));
        axios.interceptors.request.use(_this.axiosInterceptorRequestHandler.bind(_this));
        return _this;
    }
    ConnectedApp.isExpiredToken = function (error) {
        var _a, _b;
        var signatureExpired = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data).code === "SIGNATURE_EXPIRED";
        return ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 403 && signatureExpired;
    };
    ConnectedApp.prototype.axiosInterceptorResponseHandler = function (error) {
        var _a = this.props, axiosErrors = _a.axiosErrors, setAxiosError = _a.setAxiosError, tokensTypeMap = _a.axios.tokensTypeMap;
        if (ConnectedApp.isExpiredToken(error)) {
            var _b = error.config, data_1 = _b.data, url = _b.url, params_1 = _b.params;
            var expiredToken_1;
            var errorData_1 = data_1 && Object.entries(data_1).length ? JSON.parse(data_1) : {};
            if (errorData_1.token) {
                expiredToken_1 = errorData_1.token;
            }
            else if (params_1 === null || params_1 === void 0 ? void 0 : params_1.token) {
                expiredToken_1 = params_1.token;
            }
            else {
                var queryParams = url.split("?")[1];
                expiredToken_1 = new URLSearchParams(queryParams).get("token");
            }
            var tokenType = tokensTypeMap[expiredToken_1];
            return this.refreshToken(expiredToken_1, tokenType).then(function (newToken) { return axios.request(__assign(__assign({}, error.config), { url: error.config.url.replace(expiredToken_1, newToken), data: errorData_1.token ? JSON.stringify(__assign(__assign({}, errorData_1), { token: newToken })) : data_1, params: (params_1 === null || params_1 === void 0 ? void 0 : params_1.token) ? { token: newToken } : params_1 })); });
        }
        else if (axiosErrors && error.response) {
            var status_1 = error.response.status;
            var cfg = axiosErrors[status_1];
            if (cfg) {
                this.generateStatusErrorDialog(status_1, error, cfg);
            }
            else {
                setAxiosError(error);
            }
        }
        else {
            setAxiosError(error);
        }
        return Promise.reject(error);
    };
    ConnectedApp.prototype.axiosInterceptorRequestHandler = function (request) {
        if (request.url) {
            var amazonS3ContentRequest = /(^S3:\/\/.*)|(^http(s?):\/\/(.?)+s3.+amazonaws\.com)/i.test(request.url);
            if (!amazonS3ContentRequest) {
                var separatedUrl = request.url.split("?");
                if (separatedUrl[1]) {
                    var queryParameters = separatedUrl[1].split("&");
                    separatedUrl[1] = queryParameters.map(queryEncoder).join("&");
                    request.url = separatedUrl.join("?");
                }
            }
        }
        return request;
    };
    ConnectedApp.prototype.generateStatusErrorDialog = function (status, error, cfg) {
        var _a, _b;
        var code = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
        var translatePath = "errors." + status;
        if (!!code) {
            var codes = cfg.codes;
            var codeCfg = codes === null || codes === void 0 ? void 0 : codes.find(function (_a) {
                var name = _a.name;
                return name === code;
            });
            if (codeCfg) {
                this.generateStatusCodeErrorDialog(status, error, codeCfg);
            }
            else {
                this.createErrorDialog(translatePath, error, cfg);
            }
        }
        else {
            this.createErrorDialog(translatePath, error, cfg);
        }
    };
    ConnectedApp.prototype.generateStatusCodeErrorDialog = function (status, error, codeCfg) {
        var name = codeCfg.name;
        var translatePath = "errors." + status + ".codes." + name;
        this.createErrorDialog(translatePath, error, codeCfg);
    };
    ConnectedApp.prototype.createErrorDialog = function (translatePath, error, cfg) {
        var _a = this.props, translate = _a.translate, setAxiosError = _a.setAxiosError;
        var dialog = cfg.dialog, dialogConfig = cfg.dialogConfig, customOkText = cfg.customOkText, customCancelText = cfg.customCancelText;
        if (dialog) {
            var title = translate(translatePath + ".title.text");
            var content = translate(translatePath + ".content.text");
            var okText = void 0;
            if (customOkText) {
                okText = translate(translatePath + ".confirmationButtonText.text");
            }
            var cancelText = void 0;
            if (customCancelText) {
                cancelText = translate(translatePath + ".cancellationButtonText.text");
            }
            dialog(Object.assign({
                title: title,
                content: content,
                okText: okText,
                cancelText: cancelText,
                onOk: function () {
                    setAxiosError(error);
                }
            }, dialogConfig));
        }
    };
    ConnectedApp.prototype.refreshToken = function (expiredToken, tokenType) {
        var _this = this;
        if (tokenType === TokenType.JOB) {
            return axios.get(this.props.fluxUrl + "/project/job/phase/refresh?token=" + expiredToken).then(function (_a) {
                var _b = _a.data, token = _b.token, jobId = _b.jobId, phaseName = _b.phaseName;
                _this.props.setToken({
                    token: token,
                    tokenKey: jobId + "_" + phaseName,
                    tokenType: TokenType.JOB
                });
                return Promise.resolve(token);
            });
        }
        else if (tokenType === TokenType.PROJECT) {
            return axios.get(this.props.fluxUrl + "/project/refresh?token=" + expiredToken).then(function (_a) {
                var _b = _a.data, token = _b.token, projectId = _b.projectId;
                _this.props.setToken({
                    token: token,
                    tokenKey: projectId,
                    tokenType: TokenType.PROJECT
                });
                return Promise.resolve(token);
            });
        }
        return axios.get(this.props.fluxUrl + "/project/job/task/phase/refresh?token=" + expiredToken).then(function (_a) {
            var _b = _a.data, token = _b.token, taskId = _b.taskId, phaseName = _b.phaseName;
            _this.props.setToken({
                token: token,
                tokenKey: taskId + "_" + phaseName
            });
            return Promise.resolve(token);
        });
    };
    ConnectedApp.prototype.render = function () {
        var _a = this.props, userManager = _a.userManager, user = _a.user, axios = _a.axios, i18n = _a.i18n, store = _a.store, editorInitialized = _a.editorInitialized, preserveExpired = _a.preserveExpired;
        var authorized = ((user && !user.expired) || (editorInitialized && preserveExpired));
        var mountApp = axios.ready && i18n.ready && authorized;
        return userManager ? (React.createElement(OidcProvider, { store: store, userManager: userManager },
            React.createElement(LocalizeProvider, { store: store },
                React.createElement(ConnectedRouter, { history: history },
                    React.createElement(Switch, null, mountApp && this.props.children))))) : React.createElement(React.Fragment, null);
    };
    return ConnectedApp;
}(React.Component));
function mapStateToProps(state) {
    return {
        userManager: state.userManager,
        user: state.oidc.user,
        axios: state.axios,
        i18n: state.i18n,
        translate: getTranslate(state.localize),
        fluxUrl: state.serviceProperties.fluxUrl,
        editorInitialized: state.editor.initialized,
    };
}
var mapDispatchToProps = {
    setAxiosError: setAxiosError,
    setToken: setToken
};
export default connect(mapStateToProps, mapDispatchToProps)(ConnectedApp);
